import React, { useCallback, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Switch } from 'antd';
import classNames from 'classnames';

import { HeaderLogo } from 'src/features/header/Header';

import { ROUTE } from 'src/constants';

import {
  // BlockIcon,
  BlogIcon,
  CurrenciesIcon,
  DirectionsIcon,
  // NewsIcon,
  // ReservesIcon,
  ReviewsIcon,
  UsdBtcIcon,
  UsersIcon,
} from 'src/assets';

import './adminMenu.scss';

const navigationData = [
  {
    icon: UsdBtcIcon,
    label: 'requests',
    to: ROUTE.ADMIN.ORDERS.MAIN,
  },
  // {
  //   icon: ReservesIcon,
  //   label: 'reserves',
  //   to: ROUTE.ADMIN.RESERVE_REQUESTS.MAIN,
  //   disabled: true,
  // },
  // {
  //   icon: BlockIcon,
  //   label: 'block',
  //   to: ROUTE.ADMIN.BLOCKING_DETAILS.MAIN,
  //   disabled: true,
  // },
  {
    icon: DirectionsIcon,
    label: 'directions',
    to: ROUTE.ADMIN.EXCHANGE_DIRECTION.MAIN,
  },
  {
    icon: ReviewsIcon,
    label: 'reviews',
    to: ROUTE.ADMIN.REVIEWS.MAIN,
  },
  // {
  //   icon: NewsIcon,
  //   label: 'news',
  //   to: ROUTE.ADMIN.NEWS.MAIN,
  //   disabled: true,
  // },
  // {
  //   icon: BlogIcon,
  //   label: 'blog',
  //   to: ROUTE.ADMIN.BLOG.MAIN,
  //   disabled: true,
  // },
  {
    icon: BlogIcon,
    label: 'cashExchanges',
    to: ROUTE.ADMIN.CASH_EXCHANGE.MAIN,
  },
  {
    icon: CurrenciesIcon,
    label: 'currencies',
    to: ROUTE.ADMIN.CURRENCIES.MAIN,
  },
  {
    icon: UsersIcon,
    label: 'users',
    to: ROUTE.ADMIN.USERS.MAIN,
  },
  {
    icon: UsersIcon,
    label: 'admins:main',
    to: ROUTE.ADMIN.ADMINS.MAIN,
  },
];

export const AdminMenu = () => {
  const { t } = useTranslation('adminMenu');
  const { pathname } = useLocation();

  const [isOnline, setIsOnline] = useState(true);
  const [isTechnical, setIsTechnical] = useState(false);

  const onChangeOnline = useCallback((checked) => {
    setIsOnline(checked);
  }, []);

  const onChangeTechnical = useCallback((checked) => {
    setIsTechnical(checked);
  }, []);

  const renderItem = useCallback(
    (key, item) => {
      const { icon, label, to, disabled = false } = item;

      const linkStyles = classNames('admin-menu__item', {
        'admin-menu__item--active': pathname.includes(to),
        'admin-menu__item--disabled': disabled,
      });

      const disabledProps = !disabled ? { to } : {};

      return (
        <Link key={key} {...disabledProps} className={linkStyles}>
          <img src={icon} alt={icon} />
          <h5>{t(label)}</h5>
        </Link>
      );
    },
    [pathname, t],
  );

  return (
    <div className="admin-menu">
      <HeaderLogo />
      <div className="admin-menu__content">
        {navigationData?.map((item, index) => renderItem(index, item))}
      </div>

      <div className="admin-menu__toggle">
        <div className="admin-menu__toggle__item">
          <Switch
            checked={isOnline}
            className={isOnline ? 'admin-menu__button--checked' : 'admin-menu__button--unchecked'}
            onChange={onChangeOnline}
          />
          {t('online')}
        </div>
        <div className="admin-menu__toggle__item">
          <Switch
            checked={isTechnical}
            className={
              isTechnical ? 'admin-menu__button--checked' : 'admin-menu__button--unchecked'
            }
            onChange={onChangeTechnical}
          />
          {t('technical')}
        </div>
      </div>
    </div>
  );
};
